import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  fetchLeaderboard,
  selectLeaderboardData,
  selectLeaderboardError,
  selectLeaderboardLoading,
  selectUserRank,
  AppDispatch
} from '@/shared';

export const useLeaderboard = (defaultLoading = true) => {
  const dispatch = useDispatch<AppDispatch>(); // Use the AppDispatch type for dispatch
  const userRankData = useSelector(selectUserRank);
  const leaderboardData = useSelector(selectLeaderboardData);
  const loading = useSelector(selectLeaderboardLoading);
  const error = useSelector(selectLeaderboardError);

  // Fetch airdrop info on mount and set up refresh every minute
  useEffect(() => {
    if (!(userRankData || leaderboardData) && defaultLoading) {
      dispatch(fetchLeaderboard({}));
    }
  }, [dispatch, userRankData, leaderboardData]);

  // Manual refresh
  const refresh = () => {
    if (!loading) {
      dispatch(fetchLeaderboard({}));
    }
  };

  return { userRankData, leaderboardData, loading, error, refresh };
};
